// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Compose from "../Data.Functor.Compose/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var FormErrors = function (x) {
    return x;
};
var Final = function (x) {
    return x;
};
var showFormErrors = /* #__PURE__ */ Data_Map_Internal.showMap(/* #__PURE__ */ Data_Maybe.showMaybe(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString)))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "fieldLabel";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "fieldName";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "internal";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "message";
    }
})(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showBoolean))(/* #__PURE__ */ Data_Maybe.showMaybe(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString))))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))));
var semigroupFormErrors = {
    append: function (v) {
        return function (v1) {
            return Data_Map_Internal.union(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))(v)(v1);
        };
    }
};
var newtypeFormErrors_ = {
    Coercible0: function () {
        return undefined;
    }
};
var monoidFormErrors = {
    mempty: /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Data_Map_Internal.monoidMap(/* #__PURE__ */ Data_Maybe.ordMaybe(/* #__PURE__ */ Data_Ord.ordArray(Data_Ord.ordString)))),
    Semigroup0: function () {
        return semigroupFormErrors;
    }
};
var functorFinal = /* #__PURE__ */ Data_Functor_Compose.functorCompose(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.functorV);
var eqFormErrors = /* #__PURE__ */ Data_Map_Internal.eqMap(/* #__PURE__ */ Data_Maybe.eqMaybe(/* #__PURE__ */ Data_Eq.eqArray(Data_Eq.eqString)))(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
    reflectSymbol: function () {
        return "message";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "internal";
    }
})(Data_Eq.eqBoolean))()({
    reflectSymbol: function () {
        return "fieldName";
    }
})(/* #__PURE__ */ Data_Maybe.eqMaybe(/* #__PURE__ */ Data_Eq.eqArray(Data_Eq.eqString))))()({
    reflectSymbol: function () {
        return "fieldLabel";
    }
})(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString)))));
var encodeFormErrors = {
    encode: /* #__PURE__ */ (function () {
        var $29 = Foreign_Generic_Class.encode(Data_Map_Serialized.encodeMap(Data_Map_Serialized.asJSONKeyMaybe(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode))(Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode)))(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
            reflectSymbol: function () {
                return "message";
            }
        })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
            reflectSymbol: function () {
                return "internal";
            }
        })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
            reflectSymbol: function () {
                return "fieldName";
            }
        })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode)))))({
            reflectSymbol: function () {
                return "fieldLabel";
            }
        })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
            reflectSymbol: function () {
                return "message";
            }
        })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
            reflectSymbol: function () {
                return "internal";
            }
        })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
            reflectSymbol: function () {
                return "fieldName";
            }
        })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode)))))({
            reflectSymbol: function () {
                return "fieldLabel";
            }
        })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode)))))))));
        var $30 = Data_Newtype.unwrap();
        return function ($31) {
            return $29(Data_Map_Serialized.SerializedMap($30($31)));
        };
    })()
};
var decodeFormErrors = {
    decode: /* #__PURE__ */ (function () {
        var $32 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))((function () {
            var $35 = Data_Newtype.wrap();
            return function ($36) {
                return $35(Data_Map_Serialized.fromSerializedMap($36));
            };
        })());
        var $33 = Foreign_Generic_Class.decode(Data_Map_Serialized.decodeMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))(Data_Map_Serialized.asJSONKeyMaybe(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode))(Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode)))(Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
            reflectSymbol: function () {
                return "message";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
            reflectSymbol: function () {
                return "internal";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
            reflectSymbol: function () {
                return "fieldName";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode))))())({
            reflectSymbol: function () {
                return "fieldLabel";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
            reflectSymbol: function () {
                return "message";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
            reflectSymbol: function () {
                return "internal";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
            reflectSymbol: function () {
                return "fieldName";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode))))())({
            reflectSymbol: function () {
                return "fieldLabel";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))()))))));
        return function ($34) {
            return $32($33($34));
        };
    })()
};
var applyFinal = /* #__PURE__ */ Data_Functor_Compose.applyCompose(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Data_Validation_Semigroup.applyV(semigroupFormErrors));
var applicativeFinal = /* #__PURE__ */ Data_Functor_Compose.applicativeCompose(Specular_FRP_Base.applicativeDynamic)(/* #__PURE__ */ Data_Validation_Semigroup.applicativeV(semigroupFormErrors));
var userVisibleErrors = function (errors) {
    return Data_Newtype.wrap()(Data_Map_Internal.singleton(Data_Maybe.Nothing.value)(Data_Functor.mapFlipped(Data_Functor.functorArray)(errors)(function (message) {
        return {
            fieldName: Data_Maybe.Nothing.value,
            fieldLabel: Data_Maybe.Nothing.value,
            message: message,
            internal: false
        };
    })));
};
var userVisibleError = function (message) {
    return userVisibleErrors([ message ]);
};
var unFinalV = function (v) {
    return v;
};
var semigroupFinal = function (dictSemigroup) {
    return {
        append: Control_Apply.lift2(applyFinal)(Data_Semigroup.append(dictSemigroup))
    };
};
var monoidFinal = function (dictMonoid) {
    return {
        mempty: Control_Applicative.pure(applicativeFinal)(Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupFinal(dictMonoid.Semigroup0());
        }
    };
};
var makeFinalV = function ($37) {
    return Final(Data_Functor_Compose.Compose($37));
};
var internalError = function (message) {
    return Data_Newtype.wrap()(Data_Map_Internal.singleton(Data_Maybe.Nothing.value)([ {
        fieldName: Data_Maybe.Nothing.value,
        fieldLabel: Data_Maybe.Nothing.value,
        message: message,
        internal: true
    } ]));
};
var unknownError = /* #__PURE__ */ internalError("Unknown error");
var invalidFinal = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(/* #__PURE__ */ Data_Validation_Semigroup.invalid(unknownError));
var makeFinal = /* #__PURE__ */ (function () {
    var $38 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.maybe(Data_Validation_Semigroup.invalid(unknownError))(Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(semigroupFormErrors))));
    return function ($39) {
        return makeFinalV($38($39));
    };
})();
var liftDynamic = /* #__PURE__ */ (function () {
    var $40 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create);
    return function ($41) {
        return makeFinal($40($41));
    };
})();
var liftMaybe = /* #__PURE__ */ (function () {
    var $42 = Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
    return function ($43) {
        return makeFinal($42($43));
    };
})();
var heytingAlgebraFinal = function (dictHeytingAlgebra) {
    return {
        ff: Control_Applicative.pure(applicativeFinal)(Data_HeytingAlgebra.ff(dictHeytingAlgebra)),
        tt: Control_Applicative.pure(applicativeFinal)(Data_HeytingAlgebra.tt(dictHeytingAlgebra)),
        implies: Control_Apply.lift2(applyFinal)(Data_HeytingAlgebra.implies(dictHeytingAlgebra)),
        conj: Control_Apply.lift2(applyFinal)(Data_HeytingAlgebra.conj(dictHeytingAlgebra)),
        disj: Control_Apply.lift2(applyFinal)(Data_HeytingAlgebra.disj(dictHeytingAlgebra)),
        not: Data_Functor.map(functorFinal)(Data_HeytingAlgebra.not(dictHeytingAlgebra))
    };
};
var hasFieldFinal = function (dictHasField) {
    return {
        getField: function (label) {
            return Data_Functor.map(functorFinal)(Data_Record.getField(dictHasField)(label));
        }
    };
};
var getErrors = /* #__PURE__ */ (function () {
    var $44 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.validation((function () {
        var $46 = Data_Array.fromFoldable(Data_Map_Internal.foldableMap);
        var $47 = Data_Newtype.unwrap();
        return function ($48) {
            return Data_Array.concat($46($47($48)));
        };
    })())(function (v) {
        return [  ];
    }));
    return function ($45) {
        return $44(unFinalV($45));
    };
})();
var fromValidV = /* #__PURE__ */ (function () {
    return Data_Validation_Semigroup.validation(Data_Function["const"](Data_Maybe.Nothing.value))(Data_Maybe.Just.create);
})();
var unFinal = function (v) {
    return Data_Functor.map(Specular_FRP_Base.functorDynamic)(fromValidV)(v);
};
var bindFinal = function (v) {
    return function (k) {
        return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(v)(function (x) {
            return Data_Validation_Semigroup.validation((function () {
                var $49 = Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
                return function ($50) {
                    return $49(Data_Validation_Semigroup.invalid($50));
                };
            })())(function (x$prime) {
                var v1 = k(x$prime);
                return v1;
            })(x);
        });
    };
};
var additiveFinal = function (dictAdditive) {
    return {
        zero: Control_Applicative.pure(applicativeFinal)(Data_Numeric.zero(dictAdditive)),
        add: Control_Apply.lift2(applyFinal)(Data_Numeric.add(dictAdditive)),
        sub: Control_Apply.lift2(applyFinal)(Data_Numeric.sub(dictAdditive))
    };
};
export {
    FormErrors,
    fromValidV,
    liftDynamic,
    Final,
    bindFinal,
    unknownError,
    internalError,
    userVisibleError,
    userVisibleErrors,
    makeFinal,
    makeFinalV,
    liftMaybe,
    unFinal,
    unFinalV,
    invalidFinal,
    getErrors,
    newtypeFormErrors_,
    semigroupFormErrors,
    monoidFormErrors,
    eqFormErrors,
    showFormErrors,
    encodeFormErrors,
    decodeFormErrors,
    functorFinal,
    applyFinal,
    applicativeFinal,
    heytingAlgebraFinal,
    semigroupFinal,
    monoidFinal,
    additiveFinal,
    hasFieldFinal
};
//# sourceMappingURL=index.js.map
